var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotificationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.0033 0.913574L9.99629 0.913574V2.88906L9.26969 2.68935C8.4385 2.46089 7.56108 2.46089 6.7299 2.68935L6.0033 2.88906V0.913574ZM2.62927 10.8043C2.62927 11.247 2.57314 11.6826 2.4649 12.102L0.329102 17.138L15.6706 17.138L13.5276 12.102C13.4195 11.6826 13.3634 11.2471 13.3634 10.8043V8.65743C13.3634 5.68539 10.9558 3.26758 7.99627 3.26758C5.03683 3.26758 2.62927 5.68539 2.62927 8.65743L2.62927 10.8043ZM6.25549 19.7018H9.78614V17.9365H6.25549L6.25549 19.7018Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationIcon);
export default __webpack_public_path__ + "static/media/notification-icon.2cb76bd0b79f2595170f493e07b96d4d.svg";
export { ForwardRef as ReactComponent };